import React from 'react'
import {GppBad, GppGood, GppMaybe} from "@mui/icons-material";

const PlaylistStatusIndication = ({playlist}) => {

    const getPlaylistStatus = () => {
        let pStatus = 'approved'

        for (let scoredScene of playlist.scoredScenes) {
            const status = scoredScene?.statusInfo?.status
            if (status === 'rejected') {
                pStatus = 'erroneous'
                break;
            }
            if (!status || status === 'draft') {
                pStatus = 'unapproved'
            }
        }

        return pStatus
    }

    const status = getPlaylistStatus()

    if (!status) {
        return ''
    }

    if (status === 'approved') {
        return <GppGood style={{height: 35, width: 35, color: "green"}}/>
    }

    if (status === 'unapproved') {
        return <GppMaybe style={{height: 35, width: 35, color: "orange"}}/>
    }

    if (status === 'erroneous') {
        return <GppBad style={{height: 35, width: 35, color: "red"}}/>
    }

    return ''
}
export default PlaylistStatusIndication
